module.exports = __webpack_public_path__ + "img/story004@2x.8776154a.png";